import { useConfig } from "../authHooks";
import { redirectToProvider } from "../api_client/allauth";
import { useParams } from "react-router-dom";

// This component is needed for the Web extension (iframe-based) experience, since OAuth flows cannot be completed from inside iframes (and thus we launch this component as an intermediary popup)
export default function LoginWebExtensionProviderPopup(props: any) {
  const { providerId } = useParams();

  const config = useConfig();
  const providers = config.data.socialaccount.providers;
  if (!providers.length) {
    return null;
  }

  redirectToProvider(providerId, "/account/provider/callback/web-extension-popup");

  return <div>Redirecting you to login page...</div>;
}
